import { useDispatch, useSelector } from 'react-redux';
import { Selector } from '@rematch/select';
import store from '../../../../../store';
import { VerificationIssueBanner } from '../../../../provider/StripeVerificationBanner/StripeVerificationBanners';
import { IRootDispatch, RootState } from '../../../../../store/models';
import { useOnce } from '../../../../../hooks';

const useVerificationErrorBanner = (enabled: boolean) => {
  const dispatch = useDispatch<IRootDispatch>();
  const banner = useSelector<RootState, VerificationIssueBanner>(
    store.select.stripeIdentityVerification.banner as Selector<RootState, VerificationIssueBanner>,
  );

  useOnce(() => {
    dispatch.stripeIdentityVerification.load();
  }, !!enabled || null);

  return {
    banner,
    shouldShow: !!enabled && !!banner,
  };
};

export default useVerificationErrorBanner;
